<div class="col-md-10 col-sm-12 source-div">
    
    <div role="radiogroup">
        <label class="switch mar-lt">

            <input type="checkbox" class="switch-input" tabindex="-1">
            <span class="access" tabindex="-1">Toggle label</span>
            <span [ngClass]="focusOnLblOne" class="adjustFocusToLeft" aria-hidden="true" tabindex="-1"></span>
            <span [ngClass]="focusOnLblTwo" class="adjustFocusToRight" aria-hidden="true" tabindex="-1"></span>
            <span class="switch-toggle toggleLeft reflect" [ngClass]="switchLblOne" aria-hidden="true" role="radio" [attr.aria-label]="label1test" tabindex="0"
                id="{{config.id}}{{label1test}}" (keyup.enter)="emitToggleOptions(this.label1test)" (click)="emitToggleOptions(this.label1test)">{{label1test}}</span>
            <!--label1 -->

            <span class="switch-toggle toggleRight reflect" [ngClass]="switchLblTwo" aria-hidden="true" role="radio" [attr.aria-label]="label2test" tabindex="0"
                id="{{config.id}}{{label2test}}" (keyup.enter)="emitToggleOptions(this.label2test)" (click)="emitToggleOptions(this.label2test)">{{label2test}}</span>
            <!--label2-->
        </label>
    </div>
</div>
<div *ngIf="!parent.valid && parent.errors" class="col-md-12 form-validation-error">
    <i class="icon icon-error " aria-hidden="true "></i>
    <p *ngIf="parent.errors && parent.errors.notValid">Please make a selection</p>
    <p *ngIf="isInvalidPattern(parent)">{{patternErrorMessage}}</p>
</div>